
import Skeleton from '@/components/skeleton/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import PhotoUpload from '@/components/avatar_upload/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { isString, pick } from 'lodash'
import { WinpressService } from '@/services'
import { IMG_HOST } from '@/config/env'
import { typeStorage } from '@/views/winpress/article/index.vue'

@Component({
    name: '',
    components: {
        CreateDetailLayout,
        Skeleton,
        PhotoUpload
    }
})
export default class extends Vue {
    private updateLoading = false
    private form = {
        name: '',
        icon: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入分类名称' }],
        icon: [{ required: true, validator: this.iconValidator, trigger: 'none' }]
    }
    private file!: any

    created() {
        this.file = null
        this.$title('文章分类详情 | 麦媒云 - 庖丁')
        this.fetchData()
    }
    fetchData() {
        const result = typeStorage.get()
        const isMatchId = String(result.id) === this.$route.params.id
        if (!result || !isMatchId) {
            typeStorage.clear()
            return this.$router.replace('/winpress/article')
        }
        this.form = result
        this.$title(`${result.name} | 文章分类详情 - 庖丁`)
        this.$once('hook:beforeDestroy', () => {
            // 清理 localStorage
            typeStorage.clear()
        })
    }
    iconValidator(rule: any, value: any, callback: Function) {
        if (!this.file) {
            callback(new Error('请选择图标'))
        }
        callback()
    }
    onPhotoChange() {
        this.file = (this.$refs.photoRef as any).getFile()
    }
    onUpdate() {
        (this.$refs.form as ElForm).validate(async isValid => {
            if (!isValid) return
            if (isString(this.file)) {
                this.form.icon = this.file
            } else {
                // 上传图片
                const result = await new UploadImg(this.file).upload()
                if (result.error) {
                    return this.$merror('图片上传失败，请稍后再试')
                }
                this.form.icon = IMG_HOST + result.key as string
            }
            this.updateLoading = true
            await this.updateArticleType()
            this.updateLoading = false
        })
    }
    async updateArticleType() {
        const params = pick(this.form, ['id', 'name', 'icon'])
        debugger
        const result = await WinpressService.updateArticleType(params)
        if (result.status === 200) {
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
